import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Spinner } from "../components/common";

export default function AdminPinSetup() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!/^\d{4}$/.test(pin)) return toast.error("Enter a 4-digit PIN");
    setBusy(true);
    try {
      await api.post("/admin/pin/setup", { token, pin });
      toast.success("Admin PIN set. You can now sign in.");
      nav("/login");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background px-6">
      <div className="w-full max-w-sm text-center" data-testid="admin-pin-setup">
        <div className="mx-auto grid place-items-center w-16 h-16 rounded-2xl text-white mb-4" style={{ background: "#4C1D95" }}><KeyRound size={30} /></div>
        <h1 className="font-display text-2xl font-semibold">Set your admin PIN</h1>
        <p className="text-sm text-muted-foreground mt-1">Choose a 4-digit PIN for secure admin access.</p>
        {!token && <p className="text-sm text-destructive mt-4">Missing or invalid setup link.</p>}
        <input data-testid="pin-setup-input" autoFocus inputMode="numeric" maxLength={4} value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          className="mt-6 w-full h-16 text-center text-3xl tracking-[0.6em] font-mono rounded-2xl bg-secondary border border-transparent focus:border-primary outline-none" placeholder="••••" />
        <button data-testid="pin-setup-submit" onClick={submit} disabled={busy || !token}
          className="w-full h-13 mt-4 py-3 rounded-2xl text-white font-semibold flex items-center justify-center gap-2 disabled:opacity-60" style={{ background: "#6D28D9" }}>
          {busy ? <Spinner className="w-5 h-5" /> : "Set PIN"}
        </button>
      </div>
    </div>
  );
}
